import { Icon } from '@cbhq/cds-web/icons';
import { HStack } from '@cbhq/cds-web/layout';
import { Spinner } from '@cbhq/cds-web/loaders/Spinner';
import { TextBody } from '@cbhq/cds-web/typography';

export type BaseL3ValidationItemProps = {
  label: string;
  isLoading?: boolean;
  isValid?: boolean;
};

export function BaseL3ValidationItem({ label, isLoading, isValid }: BaseL3ValidationItemProps) {
  return (
    <HStack alignItems="center" gap={2}>
      {isLoading && <Spinner size={1} />}
      {!isLoading && !isValid && <Icon name="close" size="s" color="negative" />}
      {!isLoading && isValid && <Icon name="checkmark" size="s" color="positive" />}
      <TextBody as="p" color="foregroundMuted">
        {label}
      </TextBody>
    </HStack>
  );
}
